import { render, staticRenderFns } from "./count-down.vue?vue&type=template&id=fcba1912&scoped=true&"
import script from "./count-down.vue?vue&type=script&lang=js&"
export * from "./count-down.vue?vue&type=script&lang=js&"
import style0 from "./count-down.vue?vue&type=style&index=0&id=fcba1912&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba1912",
  null
  
)

export default component.exports